/**
 * Created by work on 17/3/28.
 */
import {fetchRequest} from '../../lib/network/request';
import config from '../../config';
const jsApiList = [
  'checkJsApi',
  'onMenuShareTimeline',
  'onMenuShareAppMessage',
  'hideMenuItems',
  'showMenuItems',
  'chooseImage',
  'previewImage',
  'uploadImage',
  'scanQRCode',
  'openAddress',
  'chooseWXPay',
  'getLocalImgData'
];
const isIos = window.navigator.userAgent.match(/(iPhone|iPod|ios|iPad)/i);
let configSuccess = false;
const getWxConfig = () => {
  const promise = new Promise((resolve, reject) => {
    if (isIos && configSuccess) {
      console.log('wx ready before');
      resolve();
    }
    fetchRequest(`${config.apiPrefix}/js-signature`,
      {method: 'POST', body: JSON.stringify({url: `${window.location.pathname}${window.location.search}`})})
      .then(json => {
        if (json.retCode === 0) {
          wx.config({
            debug: false,
            appId: json.data.appId,
            timestamp: json.data.timestamp,
            nonceStr: json.data.noncestr,
            signature: json.data.signature,
            jsApiList
          });
          wx.ready(() => {
            configSuccess = true;
            console.log('wx ready');
            resolve();
          });
        } else {
          reject(new Error('failed to get js signature'));
        }
      })
      .catch(err => {
        if (process.env.NODE_ENV !== 'production') {
          if (/ip(hone|od|ad)|android|WindowsPhone/i.test(window.navigator.userAgent)) {
            alert(err);
          }
          console.error(err);
        }
      });
    wx.error(res => {
      if (res.errMsg === 'config:require subscribe') {
        reject(new Error('unFocus'));
        alert('您还没有关注索真基因微信公众号！');
      }
    });
  });
  return promise;
};
export default getWxConfig;


// WEBPACK FOOTER //
// ./src/lib/weixin/getWxConfig.js